<template>
  <div class="bg-white padding-five-all margin-top-ten gestor-centralizado-resumen">
    <h6 class="gestor-centralizado-resumen__title">{{ title }}</h6>
    <div class="gestor-centralizado-resumen__grid">
      <div
        v-for="field in fields"
        :key="field.key"
        class="gestor-centralizado-resumen__cell"
      >
        <div
          class="gestor-centralizado-resumen__label"
          :class="{ 'gestor-centralizado-resumen__label--penalidad': field.penalidad }"
        >
          {{ field.label }}
        </div>
        <div class="gestor-centralizado-resumen__value">
          <b-spinner v-if="loading" small class="mr-1" />
          <span>{{ formatMoney(resumen[field.key]) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatMoney } from "@/services/gestor-centralizado/gestor-centralizado.formatters";
import {
  getResumenFields,
  MESSAGES,
} from "@/services/gestor-centralizado/gestor-centralizado.constants";

export default {
  name: "GestorCentralizadoResumen",

  props: {
    resumen: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: MESSAGES.RESUMEN_TITLE,
    },
  },

  data() {
    return {
      fields: getResumenFields(),
    };
  },

  methods: {
    formatMoney,
  },
};
</script>
